export default {"src":"/_next/static/media/help-outlined.391757e1.svg","height":24,"width":24};